import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import api from "../../api/client";
import { Card, CardContent, CardHeader, CardTitle } from "../../components/ui/card";
import { Button } from "../../components/ui/button";
import { Loader2 } from "lucide-react";

export default function RecruiterProfilePage() {
 const [profile, setProfile] = useState(null);
 const [loading, setLoading] = useState(true);
 const navigate = useNavigate();

 useEffect(() => {
 const fetchProfile = async () => {
 try {
 const res = await api.get( `${process.env.REACT_APP_API_URL || "http://localhost:5000"}/api/recruiter/profile`); // your GET profile endpoint
 if (res.data) {
 setProfile(res.data);
 }
 } catch (err) {
 console.error(err);
 } finally {
 setLoading(false);
 }
 };
 fetchProfile();
 }, []);

 if (loading) {
 return (
 <div className="flex items-center justify-center min-h-screen">
 <Loader2 className="w-10 h-10 animate-spin text-indigo-600" />
 </div>
 );
 }

 if (!profile) {
 return (
 <div className="flex items-center justify-center min-h-screen text-foreground/90">
 Recruiter profile not found.
 </div>
 );
 }

 return (
 <div className="min-h-screen py-10 px-4 sm:px-6 lg:px-8">
 <div className="max-w-3xl mx-auto space-y-6">
 {/* Header */}
 <div className="flex justify-between items-center">
 <h1 className="text-3xl font-bold text-foreground">Recruiter Profile</h1>
 <Button
 onClick={() => navigate("/recruiter/profile/edit")}
 className="bg-indigo-600 hover:bg-indigo-700 text-white px-5 py-2 rounded-lg"
 >
 Edit Profile
 </Button>
 </div>

 {/* Profile Card */}
 <Card className="shadow-lg border border-gray-200">
 <CardHeader>
 <CardTitle className="text-xl font-semibold text-foreground/80">Company Information</CardTitle>
 </CardHeader>
 <CardContent className="space-y-6">
 {/* Logo */}
 <div className="flex justify-center md:justify-start">
 {profile.logoUrl ? (
 <img
 src={profile.logoUrl ? `${process.env.REACT_APP_API_URL || "http://localhost:5000"}/${profile.logoUrl}` : "/placeholder.png"}
 alt="Company Logo"
 className="h-32 w-32 object-contain border rounded-lg"
 />
 ) : (
 <div className="h-32 w-32 flex items-center justify-center border rounded-lg text-muted-foreground/80">
 No Logo
 </div>
 )}
 </div>

 {/* Company Details */}
 <div className="space-y-3">
 <Detail label="Company Name" value={profile.companyName} />
 <Detail label="About" value={profile.about} />
 <Detail label="Location" value={profile.location} />
 <Detail
 label="Website"
 value={
 profile.website ? (
 <a
 href={profile.website}
 target="_blank"
 rel="noopener noreferrer"
 className="text-indigo-600 hover:underline"
 >
 {profile.website}
 </a>
 ) : (
 "-"
 )
 }
 />
 <Detail
 label="Approval Status"
 value={
 <span
 className={`font-medium ${
 profile.isApproved ? "text-green-600" : "text-red-600"
 }`}
 >
 {profile.isApproved ? "Approved" : "Pending Approval"}
 </span>
 }
 />
 </div>
 </CardContent>
 </Card>
 </div>
 </div>
 );
}

// Simple reusable component for label + value
function Detail({ label, value }) {
 return (
 <div>
 <h3 className="text-foreground/90 font-semibold">{label}</h3>
 <p className="text-foreground">{value || "-"}</p>
 </div>
 );
}
